module.exports = __webpack_public_path__ + "static/media/abrc-banner-small.9f57bd33.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/abrc-banner-small.png
// module id = 598
// module chunks = 0